<template>
  <b-overlay v-if="isDataLoad" :show="showOverlay" rounded="sm">
    <!-- <p>
      {{ complaintGroupDetail.complaintId }} {{ complaintGroupDetail.isLoad }}
    </p> -->
    <LeftTab
      v-if="isDataLoaded"
      :complaintData="complaintData"
      :IsAllowDelete_PersonDataDigital="false"
      :IsReadOnly_PersonDataDigital="true"
      :personals="personals"
      :attorneys="attorneys"
      :IsEdit_CompanyDetail="false"
      :IsDeleteAble_CompanyDetail="false"
      :IsReadOnly_CompanyDetail="true"
      :IsEdit_CompanySearch="false"
      :complainantCompany="complainantCompany"
      :IsReadOnly_ComplaintDetail="true"
      :complaintDetail="complaintDetail"
      :complaintCatagoryDetail="complaintCatagoryDetail"
      :complaintDetailMultiSelect="complaintDetailMultiSelect"
      :company="complaintData"
      :IsEdit_TabAttachFiles="false"
      :attachFiles="attachFiles"
      :attachFileDate="attachFileDate"
      :attachFilesType2="attachFilesType2"
      :attachFileDateType2="attachFileDateType2"
      :fileFormstatusModel="fileFormstatusModel"
      :fileFormstatusModelDates="fileFormstatusModelDates"
      :fileFormstatusType3Model="fileFormstatusType3Model"
      :fileFormstatusType3ModelDates="fileFormstatusType3ModelDates"
      :fileFormstatusType4Model="fileFormstatusType4Model"
      :fileFormstatusType4ModelDates="fileFormstatusType4ModelDates"
      :IsEditData="false"
    />
  </b-overlay>
</template>

<script>
import { BRow, BCol, BCard, BButton, BOverlay } from "bootstrap-vue";

import LeftTab from "@/views/Complaint/components/LeftTabAction.vue";

import * as storeComplaint from "@/store/api/complaint/complaint.js";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    BOverlay,
    LeftTab,
  },
  props: {
    routeName: String,
    listRouteName: String,
    complaintGroupDetail: {},
    isLoad: false,
  },
  watch: {
    isLoad(newVal, oldVal) {
      //console.log("isLoad Prop changed: ", newVal, " | was: ", oldVal);
      this.isDataLoad = this.isLoad;
    },
    isDataLoad(newVal, oldVal) {
      //console.log("isDataLoad Prop changed: ", newVal, " | was: ", oldVal);
      if (oldVal === false && newVal === true) {
        console.log(
          "on watch trriger load data for",
          this.complaintGroupDetail.complaintId
        );
        this.getComplaintById(this.complaintGroupDetail.complaintId);
      }
    },
  },
  data() {
    return {
      isDataLoad: this.isLoad,
      isDataLoaded: false,
      showOverlay: false,

      personals: [],
      attorneys: [],
      complainantCompany: [],
      currentUserIdModal: "",
      currentCompIdModal: "",
      currentCompanyModal: {},
      complaintData: {},
      complaintDetail: [],
      complaintDetailMultiSelect: [],
      complaintCatagoryDetail: [],
      masterIdList: [],
      complainId: null,
      attachFiles: [],
      attachFileDate: [],
      attachFilesType2: [],
      attachFileDateType2: [],
      fileFormstatusModel: [],
      fileFormstatusModelDates: [],
      fileFormstatusType3Model: [],
      fileFormstatusType3ModelDates: [],
      fileFormstatusType4Model: [],
      fileFormstatusType4ModelDates: [],
      isComplaintValidate: true,
    };
  },
  mounted() {
    // if isDataLoad = true on mounted need to trigger load data
    if (this.isDataLoad === true) {
      console.log(
        "trigger load data for",
        this.complaintGroupDetail.complaintId
      );
      this.getComplaintById(this.complaintGroupDetail.complaintId);
    }
  },
  methods: {
    getComplaintById(id) {
      const _this = this;
      this.showOverlay = true;
      storeComplaint
        .getComplaintById(id)
        .then(function(response) {
          // handle success
          _this.personals = response.data.data.personals;
          _this.attorneys = response.data.data.attorneys;
          _this.complaintData = response.data.data.complaintModel;
          _this.complainantCompany = response.data.data.complainantCompany;
          _this.attachFiles = response.data.data.attachFiles;
          _this.attachFileDate = response.data.data.attachFileDate;
          _this.attachFilesType2 = response.data.data.attachFilesType2;
          _this.attachFileDateType2 = response.data.data.attachFileDateType2;
          _this.fileFormstatusModel = response.data.data.fileFormstatusModel;
          _this.fileFormstatusModelDates =
            response.data.data.fileFormstatusModelDates;
          _this.fileFormstatusType3Model =
            response.data.data.fileFormstatusType3Model;
          _this.fileFormstatusType3ModelDates =
            response.data.data.fileFormstatusType3ModelDates;
          _this.fileFormstatusType4Model =
            response.data.data.fileFormstatusType4Model;
          _this.fileFormstatusType4ModelDates =
            response.data.data.fileFormstatusType4ModelDates;
          _this.complaintDetail = response.data.data.complaintDetail;
          _this.complaintDetailMultiSelect =
            response.data.data.complaintDetailMultiSelect;
          _this.complaintCatagoryDetail =
            response.data.data.complaintCatagoryDetail;

          _this.complaintDetail.forEach((value, index) => {
            value.tmMasterList.forEach((value2, index2) => {
              if (value2.checked === true) {
                _this.masterIdList.push(value2.masterId);
              }
            });
          });
          _this.isDataLoaded = true;
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        })
        .then(function() {
          // always executed
          _this.showOverlay = false;
        });
    },
  },
};
</script>

<style></style>
